<script>
    import R from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import AppIcon from "../icons/AppIcon.svelte";
    // import ControlLoader from "../ControlLoader.svelte";
    import {setFocusTo} from "../../lib/lib";

    export let id = 'memberName';
    export let memberId = null;
    export let member = null;
    export let css = '';
    export let placeholder = '';
    export let disabled = false;

    let name = '';
    let timer;
    let results = [];
    let listIndex = -1;
    let showDropdown = false;
    let showNotFound = false;
    let loading = false;

    const dispatch = createEventDispatcher();

    const search = () => {
        const onSuccess = result => {
            if (member && member.id) {
                results = result.list.filter(x => x.id != member.id);
            } else {
                results = result.list;
            }
            loading = false;
            showNotFound = results.length === 0;
            openDropdown();
        }

        const onFailure = err => {
            loading = false;
        };

        loading = true;
        R.handle(R.member.index, {term: name}, onSuccess, onFailure);
    }

    const onFocusOut = () => {
        if (member) {
            name = (member.lastname + ' ' + member.firstname).trim();
        }
    }

    const onKeyDown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter') {
                event.preventDefault();
                if (timer) {
                    clearInterval(timer);
                }
                if (listIndex > -1) {
                    onSelect(results[listIndex]);
                } else {
                    closeDropdown();
                }
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onKeyUp = (event) => {
        if (name != event.target.value) {
            showNotFound = false;
            name = event.target.value;
            if (timer) {
                clearInterval(timer);
            }

            if (name.length) {
                timer = setInterval(() => {
                    clearInterval(timer);
                    search();
                }, 500);
            } else {
                clear();
            }
        }
    }

    const clear = () => {
        member = null;
        memberId = null;
        showNotFound = false;
        dispatch("change", null);
    }

    const onSelect = (item) => {
        memberId = item.id;
        member = item;
        name = (member.lastname + ' ' + member.firstname).trim();
        dispatch("change", member);
        closeDropdown();
    }

    // const onClear = () => {
    //     clear();
    //     name = "";
    //     setFocusTo(id);
    // }

    const openDropdown = () => {
        showDropdown = true;
    }

    const closeDropdown = () => {
        showDropdown = false;
    }

    $: {
        // if (member) {
        //     if (memberId != member.id) {
        //         memberId = member.id;
        //         name = (member.lastname + ' ' + member.firstname).trim();
        //     }
        // } else {
        //     if (memberId != null && !member) {
        //         memberId = null;
        //         name = '';
        //     }
        // }
        if (memberId && !member) {
            load();
        } else if (!memberId) {
            member = null;
            name = '';
        }
    }
</script>

<div class="dropdown-container" use:clickOutside on:click_outside="{ closeDropdown }">
    <div class="input-group">
        <input type="text" class="form-control {css}" id="{ id }" value="{ name }" on:keydown="{ onKeyDown }"
               on:keyup="{ onKeyUp }"
               on:focusout="{ onFocusOut }"
               autocomplete="off"
               {placeholder} {disabled}>
        {#if showNotFound}
            <div class="not-found">
                <AppIcon icon="exclamation-circle-solid" size="16"/>
            </div>
        {/if}
    </div>
    <!--    <ControlLoader {loading}/>-->

    {#if showDropdown}
        {#if results.length}
            <ul class="dropdown client-dropdown">
                {#each results as item, index}
                    <li class="dropdown-item d-flex align-items-center pointer" class:selected="{ listIndex === index }"
                        on:click="{ () => onSelect(item) }">
                        <div class="name">
                            { item.lastname } { item.firstname }
                            <div class="email">
                                { item.email }
                            </div>
                        </div>
                    </li>
                {/each}
            </ul>
        {/if}
    {/if}
</div>

<style>
    .not-found {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        color: rgba(255, 0, 0, 0.5);
    }

    .client-dropdown .dropdown-item .name .email {
        font-size: 12px;
        color: #777;
    }
</style>